import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationToastComponent } from '../../../../components/confirmation-toast/confirmation-toast.component';
import { DialogService } from 'src/app/services/dialog.service';
import { SupportService } from 'src/app/services/support.service';


@Component({
    selector: 'app-delete-support',
    templateUrl: './delete-support.component.html',
    styleUrl: './delete-support.component.scss',
    standalone: false
})
export class DeletesupportComponent {
  userText: string;
  
  constructor(
    public dialogRef: MatDialogRef<DeletesupportComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly supportService: SupportService,
    private readonly toast: ConfirmationToastComponent,
    private readonly dialogService: DialogService,
  ) {
    dialogRef.disableClose = true;
    this.userText = "Are you sure you want to delete the request for " + 
    (this.data.support?.assessment?.baer_name ?? (this.data.support.report.baer_name + " (" + this.data.support.report.report_num + ")")) +"?"
  }

  deleteSupport(): void {
    this.dialogService.openSpinner()
    this.supportService.deleteSupportRequest(this.data.support.support_id).subscribe({
      next: (response) => {
        this.dialogService.closeSpinner()
        this.toast.openSuccessSnackBar(`This support request been deleted from the database.`);
        this.dialogRef.close(true);
      },
      error: (response) => {
        this.dialogService.closeSpinner()
        this.toast.openErrorSnackBar("There was an error deleting the support request", "Please try deleting the support request again.");
        this.dialogRef.close(false);
      },
    })
  }

  close(): void {
    this.dialogRef.close(false);
  }
}